// extracted by mini-css-extract-plugin
export default {"doc":"Privacy_doc__2k1JM","title":"Privacy_title__BxoKW","updated":"Privacy_updated__2AYUU"};